import NextImage from 'next/image';
import { useRouter } from 'next/router';

import { useTranslation } from 'next-i18next';

import { HeaderStyle, ImageWrapper } from './style';

import { useBreakpoint, useUniversityInformation } from '@helpers/use';

const Header = () => {
  const { t } = useTranslation();
  const { isMobile } = useBreakpoint();
  const router = useRouter();
  const universityIdName = router.query.universityIdName as string;
  const { landingPage } = useUniversityInformation(universityIdName);

  return (
    <HeaderStyle>
      <ImageWrapper>
        {isMobile && landingPage?.bannerResponsiveImageUrl ? (
          <NextImage
            src={landingPage.bannerResponsiveImageUrl}
            width="100%"
            height={132}
            layout="responsive"
            objectFit="contain"
          />
        ) : (
          landingPage?.bannerImageUrl && (
            <NextImage
              src={landingPage.bannerImageUrl}
              width="100%"
              height={26.1}
              layout="responsive"
              objectFit="contain"
            />
          )
        )}
      </ImageWrapper>
    </HeaderStyle>
  );
};

export default Header;
